module.exports = __webpack_public_path__ + "static/media/Post-test for economics.b294f61b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Post-test for economics.pdf
// module id = 307
// module chunks = 0